import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import router from '@/router';
import { onMounted } from 'vue';

// Ionic
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';

// Google Maps
import { Loader } from 'google-maps';

// メモった！、キニッタ！共通
import * as GVar from '@/components/00/Var00';  // 共通変数
// import * as Tools from '@/components/00/Tools'; // 共通ツール
import * as GFunc from '@/components/00/Common00';  // 共通メソッド

// キニッタ！専用
import * as LFunc from '@/components/05/Common05002'; // キニッタ！専用メソッド

// PDF表示用
import * as pdfFonts from  'pdfmake/build/vfs_fonts';
import pdfMake from "pdfmake";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// Vue
pdfMake.vfs = pdfFonts.pdfMake.vfs


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet), { id: "router" })
    ]),
    _: 1
  }))
}
}

})